import BankCardType from '~/enums/bank-card-type'

enum OrderPaymentMethod {
  Other = '0',
  TinkoffBank = '1',
  YooKassa = '2',
  RaiffeisenBank = '3',
  Dolyame = '4',
  Payselection = '5',
  DavayDelit = '6',
  CloudPayments = '7',
}

const {
  CloudPayments,
  DavayDelit,
  Dolyame,
  Other,
  Payselection,
  RaiffeisenBank,
  TinkoffBank,
  YooKassa
} = OrderPaymentMethod

const bankCardTypeMapping = new Map([
  [CloudPayments, BankCardType.Any],
  [DavayDelit, BankCardType.Russian],
  [Dolyame, BankCardType.Russian],
  [Other, BankCardType.Any],
  [Payselection, BankCardType.International],
  [RaiffeisenBank, BankCardType.International],
  [TinkoffBank, BankCardType.Russian],
  [YooKassa, BankCardType.Any]
])

const iconDescriptionMapping = new Map([
  [CloudPayments, '—\xA0Российские карты: Visa, Mastercard и\xA0Мир.\n—\xA0Зарубежные карты: Мир, Белкарт-Мир.\n—\xA0Сервисы: СБП, SberPay, T-Pay и\xA0Mir Pay.'],
  [DavayDelit, '—\xA0Российские карты: Visa, Mastercard и\xA0Мир.'],
  [Dolyame, '—\xA0Российские карты: Visa, Mastercard и\xA0Мир.\n—\xA0Оплатите\xA025% от\xA0стоимости покупки, а\xA0оставшиеся 3\xA0части спишутся автоматически с\xA0шагом в\xA02\xA0недели. Без процентов и\xA0комиссий, как обычная оплата картой.'],
  [Other, null],
  [Payselection, '—\xA0Российские карты: Visa, Mastercard и\xA0Мир.\n—\xA0Зарубежные карты: Mastercard.'],
  [RaiffeisenBank, '—\xA0Российские карты: Visa, Mastercard, Мир и\xA0UnionPay.\n—\xA0Зарубежные карты: Мир.'],
  [TinkoffBank, '—\xA0Российские карты: Visa, Mastercard и\xA0Мир.\n—\xA0Зарубежные карты: Мир.\n—\xA0Сервисы: СБП и\xA0Tinkoff Pay.'],
  [YooKassa, '—\xA0Российские карты: Visa, Mastercard, Мир и\xA0JCB.\n—\xA0Зарубежные карты: Мир, АПРА, Белкарт-Мир, Корти Милли и\xA0Express Pay.\n—\xA0Сервисы: СБП, SberPay и\xA0ЮMoney.']
])

const iconNameMapping = new Map([
  [CloudPayments, 'payment-methods/cloudpayments'],
  [DavayDelit, 'payment-methods/davay-delit'],
  [Dolyame, 'payment-methods/dolyame'],
  [Other, null],
  [Payselection, 'payment-methods/payselection'],
  [RaiffeisenBank, 'payment-methods/raiffeisen-bank'],
  [TinkoffBank, 'payment-methods/tinkoff-bank'],
  [YooKassa, 'payment-methods/yoo-kassa']
])

const nameMapping = new Map([
  [CloudPayments, 'CloudPayments'],
  [DavayDelit, 'Давай делить'],
  [Dolyame, 'Долями'],
  [Other, 'Другой'],
  [Payselection, 'Payselection'],
  [RaiffeisenBank, 'Райффайзен Банк'],
  [TinkoffBank, 'Тинькофф Банк'],
  [YooKassa, 'ЮKassa']
])

namespace OrderPaymentMethod {
  export const sortedMembers = [
    Other,
    CloudPayments,
    YooKassa,
    TinkoffBank,
    RaiffeisenBank,
    Payselection,
    Dolyame,
    DavayDelit
  ]

  export function getBankCardType (orderPaymentMethod: OrderPaymentMethod): BankCardType {
    return bankCardTypeMapping.get(orderPaymentMethod)!
  }

  export function getIconDescription (orderPaymentMethod: OrderPaymentMethod): string {
    return iconDescriptionMapping.get(orderPaymentMethod)!
  }

  export function getIconName (orderPaymentMethod: OrderPaymentMethod): string {
    return iconNameMapping.get(orderPaymentMethod)!
  }

  export function getName (orderPaymentMethod: OrderPaymentMethod): string {
    return nameMapping.get(orderPaymentMethod)!
  }
}

export default OrderPaymentMethod
